<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <form @submit.prevent="handleSubmit" class="form-horizontal">
                    <div class="card">
                        <div class="card-body">
                            <h4 class="card-title">Sale Order #{{saleid}}</h4>
                            <h6 class="card-subtitle">You can edit sale info as sale rate etc</h6>
                        </div>
                        <hr class="m-b-0">
                        <div class=" card-blue">
                            <div class="card-body">
                                <h5 class="card-title m-t-10 p-b-20">Buyer's Info</h5>
                                <div class="row">
                                    <div class="col-sm-12 col-md-5">
                                        <div class="form-group row">
                                            <label class="col-sm-3 text-right control-label col-form-label"
                                                   for="inputEmail3">Buyer Name</label>
                                            <div class="col-sm-9">
                                                <multiselect
                                                        :class="{'is-invalid': submitted && errors.has('buyer_id')}"
                                                        :options="buyers"
                                                        :selectLabel="''"
                                                        @search-change="searchBuyer"
                                                        class="form-control"
                                                        data-vv-as="Supplier"
                                                        id="buyer_id"
                                                        label="org_name"
                                                        name="buyer_id"
                                                        open-direction="bottom"
                                                        placeholder="Select Buyer"
                                                        v-model="so.buyer"
                                                        v-validate="'required'">
                                                </multiselect>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-12 col-md-6">
                                        <div class="form-group row">
                                            <label class="col-sm-4 text-right control-label col-form-label"
                                                   for="inputEmail3">Buyer's Base Currency</label>
                                            <div class="col-sm-7">
                                                <input :value="so.total.currency_name+ ' ('+so.total.currency_symbol+')'"
                                                       class="form-control"
                                                       id="currency"
                                                       readonly
                                                       type="text"
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <h5 class="card-title m-t-10 p-b-20">Sale Item Info</h5>
                                <div class="form-group row" v-if="so.items.length === 0">
                                    <label class="col-md-2 text-right control-label col-form-label">Commodity</label>
                                    <div class="col-md-4 mt-2">
                                        <a class="" data-target="#searchAndSelectCommodityModal" data-toggle="modal"
                                           href="javascript:void(0)" v-if="so.items.length === 0"><b>Click here to
                                            add commodity</b></a>
                                    </div>
                                </div>
                                <div class="form-group row" v-for="(row, index) in so.items">
                                    <label class="col-sm-2 text-right control-label col-form-label" for="commodity_id">Commodity</label>
                                    <div class="col-sm-2">
                                        <p class="form-control" style="height: 42px;">{{row.commodity.name}} <span
                                                v-if="row.commodity.code">({{row.commodity.code}})</span> -
                                            {{row.commodity.variety}}</p>
                                    </div>
                                    <div class="col-sm-2">
                                        <input :class="{'is-invalid': submitted && errors.has('quantity')}" class="form-control"
                                               data-vv-as="Quantity"
                                               id="quantity"
                                               name="quantity"
                                               placeholder="Quantity"
                                               style="height: 42px;"
                                               type="text"
                                               v-model="row.quantity"
                                               v-validate="'numeric|min_value:1'">
                                        <div class="invalid-feedback" v-if="submitted && errors.has('quantity')">{{ errors.first('quantity') }}</div>
                                    </div>
                                    <div class="col-sm-2">
                                        <multiselect
                                                :clear-on-select="false"
                                                :close-on-select="true"
                                                :hide-selected="true"
                                                :internal-search="false"
                                                :limit="3"
                                                :max-height="600"
                                                :options="units"
                                                :options-limit="300"
                                                :searchable="true"
                                                :selectLabel="''"
                                                :show-no-results="false"
                                                @input="setUnit($event,row)"
                                                @search-change="getUnits"
                                                id="unit"
                                                label="name"
                                                name="unitid"
                                                open-direction="bottom"
                                                placeholder="Search unit"
                                                track-by="id"
                                                v-model="row.unit">
                                            <template slot="singleLabel" slot-scope="props">
                                                {{props.option.name}}
                                            </template>
                                            <template slot="option" slot-scope="props">
                                                <div class="option__desc">
                                                    <h5>{{ props.option.symbol }}</h5>
                                                    <h5>{{ props.option.name }}</h5>
                                                </div>
                                            </template>
                                            <span slot="noResult">Unit not found</span>
                                        </multiselect>
                                    </div>
                                    <div class="col-sm-2">
                                        <input :class="{'is-invalid': submitted && errors.has('rate')}" class="form-control"
                                               data-vv-as="Rate"
                                               id="rate"
                                               name="rate"
                                               placeholder="Rate"
                                               style="height: 42px;"
                                               type="text"
                                               v-model="row.rate"
                                               v-validate="'decimal:3'">
                                        <div class="invalid-feedback" v-if="submitted && errors.has('rate')">{{ errors.first('rate') }}</div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="form-group button-group">
                                            <button data-target="#searchAndSelectCommodityModal"
                                                    data-toggle="modal" class="btn btn-success" style="height: 40px"
                                                    type="button" v-if="so.items.length === 1 || index === so.items.length-1"><i
                                                    class="fa fa-plus"></i></button>
                                            <button @click="removeRow(index)" class="btn btn-danger" type="button"><i class="fa fa-minus"></i></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr class="m-t-0">
                        <div class="card-footer">
                            <div class="form-group m-b-0 text-right">
                                <div class="button-group">
                                    <button class="btn waves-effect waves-light btn-success"
                                            type="submit">Save
                                    </button>
                                    <button class="btn waves-effect waves-light btn-secondary" type="reset">Reset
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <search-select-commodity :checked-commodity-ids="commodityIds"
                                 @commodity-select="setCommodity"></search-select-commodity>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Multiselect from 'vue-multiselect';
    import UnitSelect from "../../../common/UnitSelect";
    import SearchSelectCommodity from "../../../common/SearchSelectCommodity";

    export default {
        name: "Edit",
        props: ["saleid"],
        components: {SearchSelectCommodity, Multiselect, UnitSelect},
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        data() {
            return {
                submitted: false,
                units: [],
                so: {
                    total: {
                        currency_symbol: null,
                        currency_name: null,
                    },
                    items: [
                    ]
                },
                buyers: [],
                commodityIds: [],
            }
        },
        mounted() {
            this.getSaleOrder();
        },
        methods: {
            async searchBuyer(searchText) {
                let reply = await this.$http
                    .get("/marketplaces/" + this.currentOrg.marketplace_id + "/members/search", {
                        params: {
                            search: searchText
                        }
                    });

                this.buyers = reply.data;
            },
            async getUnits(searchText) {
                let row = await this.$http.get('unit/search', {
                    params: {
                        search: searchText
                    }
                });
                this.units = row.data;
            },
            async getSaleOrder() {
                let reply = await this.$http.get("/marketplaces/" + this.currentOrg.marketplace_id + "/sales/" + this.saleid);
                this.so = reply.data;
                this.so.buyer['org_name'] = this.so.buyer.name;
                this.so.buyer['org_id'] = this.so.buyer_id;
                this.commodityIds = this.so.items.map(item=> item.commodity_id);
                this.so.items = this.so.items.map((si, i) => {
                    return {
                        ...si,
                        commodity: {
                            id: si.commodity_id,
                            name: si.name,
                            code: si.code,
                            commodity_id: si.commodity_id,
                            commodity_name: si.name,
                            variety: si.variety
                        },
                        quantity: si.quantity.amount,
                        unit_id: si.unit_id,
                        rate: si.rate.amount,
                        unit: {
                            id: si.unit_id,
                            name: si.unit_name,
                            symbol: si.unit_symbol,
                        }
                    }
                })
            },
            setUnit(e, si) {
                si.unit_symbol = e.symbol;
                si.unit_id = e.id;
            },
            addRow() {
                this.so.items.push({
                    commodity: null,
                    quantity: null,
                    unit: null,
                    rate: null
                });
            },
            removeRow(index) {
                this.so.items.splice(index, 1);
                this.commodityIds = this.so.items.map(row => row.commodity.commodity_id);
            },
            handleSubmit(e) {
                this.submitted = true;
                this.$validator.validate()
                    .then(valid => {
                        if (valid) {
                            this.update();
                        }
                    });
            },
            async update() {
                try {
                    await this.$http.put('/marketplaces/' + this.currentOrg.marketplace_id + '/sales/' + this.saleid + '/update', this.so);
                    await this.$router.push({name: "viewsale"});
                    this.$toastr('success', 'Sale order updated successfully', 'Sale Updated');
                } catch (e) {
                    if (e.response.data.status === 403) {
                        this.$toastr('error', 'You are not authorized to perform this operation', 'Failed');
                    }
                }
            },
            setCommodity(e) {
                let commodities = e;
                commodities.forEach(c=> {
                    let found = this.so.items.find(row=> row.commodity.commodity_id === c.id);
                    if(!found){
                        this.so.items.push({
                            commodity: {
                                commodity_id: c.id,
                                commodity_name: c.name,
                                unit_id: c.unit ? c.unit.id : null,
                                unit_name: c.unit ? c.unit.name : null,
                                unit_symbol: c.unit ? c.unit.symbol : null,
                                ...c
                            },
                            rate: c.rate.amount,
                            quantity: null
                        })
                    }
                })
                this.commodityIds = commodities.map(c=> c.id);

            }
        }
    }
</script>

<style scoped>

</style>
